import { LicensedPartners as LicensedPartnersContent } from '#src/LicensedPartners/index.tsx';

const LicensedParters = () => {
  return <LicensedPartnersContent />;
};

export default LicensedParters;
